import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const CustomLink = styled(Link)`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  color: ${({ theme, color }) => theme[color] || theme.dark};
`;
